module.exports = __webpack_public_path__ + "img/yb.08d93e43.png";